module.exports = __webpack_public_path__ + "assets/img/mecha-btn-09d553a9.png";